import { useState } from 'react';
import styles from './LoginForm.module.css';
import { Link } from 'react-router-dom';

export default function LoginForm({ onLogin, showResend, onResend, resendDisabled }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin({ email, password });
  };

  return (
    <div className={styles.card}>
      <div className={styles.logoContainer}>
        <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
        <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
        <p className={styles.subtitle}>Log in to your account</p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          className={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <div className={styles.forgotPassword}>
          <Link to="/forgot-password">Forgot password?</Link>
        </div>
        <button type="submit" className={styles.button}>
          Sign In
        </button>
      </form>

      {showResend && (
        <div className={styles.resendBanner}>
          <p className={styles.resendText}>Your email hasn't been verified yet.</p>
          <button
            className={styles.resendButton}
            onClick={onResend}
            disabled={resendDisabled}
          >
            {resendDisabled ? 'Email sent — check your inbox' : 'Resend verification email'}
          </button>
        </div>
      )}

      <div className={styles.divider}></div>

      <div className={styles.footerText}>
        Don't have an account? <Link to="/register">Create account</Link>
      </div>

      <div className={styles.legalLinks}>
        <a href="/privacy">Privacy</a> · <a href="/terms">Terms</a>
      </div>
    </div>
  );
}
